import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withBangingAnimator from 'containers/withBangingAnimator';
import withPendingSpinEnd from 'containers/withPendingSpinEnd';
import PointValueContainer from 'components/PointValueContainer';
import PointValueDisplay from 'components/PointValueDisplay';
import './PatronAssetsDisplay.css';

const AnimatedPointValueDisplay = withPendingSpinEnd()(
  withBangingAnimator()(PointValueDisplay)
);

function PatronAssetsDisplay({ patronAssets, history }) {
  const handleOpenVault = () => {
    history.push('/vault');
  };

  if (!patronAssets) {
    return null;
  }
  const { tickets, wscore, sapphires, gameBalance } = patronAssets;

  return (
    <div className="patron-assets-display">
      <PointValueContainer
        className="wscore-meter"
        icon="wscore"
        onClick={() => handleOpenVault()}
      >
        <AnimatedPointValueDisplay value={wscore} enableScaling />
      </PointValueContainer>

      <PointValueContainer
        className="game-balance-meter"
        icon="balance"
        onClick={() => handleOpenVault()}
      >
        <AnimatedPointValueDisplay value={gameBalance} enableScaling />
      </PointValueContainer>

      <PointValueContainer icon="sapphires" onClick={() => handleOpenVault()}>
        <AnimatedPointValueDisplay value={sapphires} enableScaling />
      </PointValueContainer>

      <PointValueContainer
        className="tickets-meter"
        icon="tickets"
        onClick={() => handleOpenVault()}
      >
        <PointValueDisplay value={tickets} />
      </PointValueContainer>
    </div>
  );
}

PatronAssetsDisplay.propTypes = {
  patronAssets: PropTypes.shape({
    tickets: PropTypes.number,
    wscore: PropTypes.number,
    sapphires: PropTypes.number,
    gameBalance: PropTypes.number
  })
};

export default withRouter(PatronAssetsDisplay);
